var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { error } from "@irati/ui/src/global/colors";
export default styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 10px;\n  position: relative;\n  top: -23px;\n\n  ", "\n"], ["\n  color: ", ";\n  font-size: 10px;\n  position: relative;\n  top: -23px;\n\n  ",
    "\n"])), error, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.desktop(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    top: 0px;\n  "], ["\n    top: 0px;\n  "])));
});
var templateObject_1, templateObject_2;
